<template>
  <div class="publicCard">
    <div id="card">
      <slot name="card"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {}
  },
  methods: {},
  components: {}
}
</script>

<style scoped>
.publicCard {
  width: 100%;
  display: flex;
  justify-content: center;
}
#card {
  box-sizing: border-box;
  width: 93.7%;
  border-radius: 20px;
  margin: 15px 0px;
  padding: 30px 20px;
  background-color: white;
  box-shadow: 0px 0px 8px rgb(200, 200, 200);
}
</style>
